import Flex from "components/grid/Flex";
import { Typography } from "@material-ui/core";
import moment from "moment";

const DateAndValue = ({ date, value, isNew, yearOnly, suffix }) => {
    return (
        <Flex item container>
            {
                date &&
                <>
                    {
                        !yearOnly &&
                        <Typography style={{ color: "#b1b1b1", minWidth: 35 }}>
                            {moment(date).format("MMM").substring(0, 3)}
                        </Typography>
                    }
                    <Typography style={{ color: isNew ? "#007bff" : "black", marginRight:5 }}>{moment(date).format("YYYY")}</Typography>
                </>
            }

            <Typography style={{ color: isNew ? "#007bff" : "black" }}>
                {value} {suffix}
            </Typography>
            {isNew && <Typography style={{ color: "#007bff", marginLeft: 10 }}> NEU </Typography>}
        </Flex>
    );
};

export default DateAndValue;
